import React, { useEffect, useMemo } from "react";
import { hasAnimatedNodes } from "./utils/has-animated-nodes.js";
import { hasPointerAnimatedNodes } from "./utils/has-pointer-animated-nodes.js";
const ANIMATION_SCOPE_ATTR = "data-ricos-animation-scope";
const animationScopeSelector = (scopeId) => `[${ANIMATION_SCOPE_ATTR}=${scopeId}] [data-ricos-animation]`;
const entranceScopeSelector = (scopeId) => `[${ANIMATION_SCOPE_ATTR}=${scopeId}] [data-ricos-entrance]`;
const animationCss = (scopeId, hasPointerNodes) => `@media (prefers-reduced-motion: no-preference){[${ANIMATION_SCOPE_ATTR}=${scopeId}]{${hasPointerNodes ? "overflow:clip" : "overflow-x:clip"}}${entranceScopeSelector(scopeId)}:not([data-ricos-entered]){visibility:hidden}}`;
const noscriptCss = (scopeId) => `${entranceScopeSelector(scopeId)}{visibility:visible !important}`;
const revealAll = (root) => root.querySelectorAll("[data-ricos-animation]").forEach((el) => el.setAttribute("data-ricos-entered", ""));
const NodeAnimations = ({ content, contentRef, enabled, scopeId }) => {
  const nodes = useMemo(() => content?.nodes ?? [], [content]);
  const hasAnimations = useMemo(() => enabled && hasAnimatedNodes(nodes), [enabled, nodes]);
  const hasPointerNodes = useMemo(
    () => hasAnimations && hasPointerAnimatedNodes(nodes),
    [hasAnimations, nodes]
  );
  useEffect(() => {
    if (!hasAnimations || !contentRef.current) {
      return;
    }
    let cancelled = false;
    let dispose;
    import("./node-animations-runtime.js").then((runtime) => {
      if (cancelled || !contentRef.current) {
        return;
      }
      try {
        dispose = runtime.initNodeAnimations(contentRef.current, nodes);
      } catch {
        revealAll(contentRef.current);
      }
    }).catch(() => {
      if (!cancelled && contentRef.current) {
        revealAll(contentRef.current);
      }
    });
    return () => {
      cancelled = true;
      dispose?.();
    };
  }, [nodes, hasAnimations, contentRef]);
  if (!hasAnimations) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("style", null, animationCss(scopeId, hasPointerNodes)), /* @__PURE__ */ React.createElement("noscript", null, /* @__PURE__ */ React.createElement("style", null, noscriptCss(scopeId))));
};
export {
  ANIMATION_SCOPE_ATTR,
  NodeAnimations,
  animationScopeSelector
};
//# sourceMappingURL=node-animations.js.map
